<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px" class="green"
  ><span class="counter" *ngIf="numReviews > 0">{{ numReviews }}</span
  ><ng-container *ngIf="numReviews === 0">
    <span *ngIf="reviewsObservable | async as reviews">{{ reviews.length }}</span>
    <span *ngIf="!reviewsObservable">{{ reviews.length }}</span> </ng-container
  ><mat-icon>verified</mat-icon>
</div>
